import { useEffect, useMemo, useState } from "react";
import { X, Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api } from "@/lib/api";
import { RELATED_TYPES, relatedMeta } from "@/data/relatedRecords";

export const RelatedPicker = ({ value = [], onChange }) => {
  const [type, setType] = useState("");
  const [recordId, setRecordId] = useState("");
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (!type) { setRows([]); return; }
    const meta = relatedMeta(type);
    api.list(meta.resource).then(setRows).catch(() => setRows([]));
    setRecordId("");
  }, [type]);

  const options = useMemo(() => {
    const meta = relatedMeta(type);
    return meta ? rows.map((r) => ({ id: r.id, name: r[meta.nameKey] || r.name || r.title || r.id })) : [];
  }, [rows, type]);

  const add = () => {
    if (!type || !recordId) return;
    const rec = options.find((o) => o.id === recordId);
    if (!rec) return;
    if (value.some((v) => v.id === rec.id && v.type === type)) return;
    onChange([...value, { type, id: rec.id, name: rec.name }]);
    setRecordId("");
  };

  return (
    <div className="space-y-2">
      <div className="flex flex-wrap items-center gap-2">
        <Select value={type} onValueChange={setType}><SelectTrigger data-testid="related-picker-type" className="w-auto min-w-[150px] border-[#E7E2D4] bg-white"><SelectValue placeholder="Record type" /></SelectTrigger><SelectContent>{RELATED_TYPES.map((t) => <SelectItem key={t.type} value={t.type}>{t.type}</SelectItem>)}</SelectContent></Select>
        <Select value={recordId} onValueChange={setRecordId} disabled={!type}><SelectTrigger data-testid="related-picker-record" className="w-auto min-w-[180px] border-[#E7E2D4] bg-white"><SelectValue placeholder="Select record" /></SelectTrigger><SelectContent>{options.map((o) => <SelectItem key={o.id} value={o.id}>{o.name}</SelectItem>)}</SelectContent></Select>
        <Button type="button" data-testid="related-add" onClick={add} disabled={!recordId} variant="outline" className="border-[#E7E2D4]"><Plus size={14} /> Link</Button>
      </div>
      {value.length > 0 && (
        <div className="flex flex-wrap gap-1.5">
          {value.map((r) => (
            <span key={`${r.type}-${r.id}`} data-testid={`related-chip-${r.id}`} className="inline-flex items-center gap-1 rounded-full bg-[#1D4ED8]/10 px-2.5 py-1 text-xs font-semibold text-[#1D4ED8]">
              {r.type}: {r.name}
              <button type="button" onClick={() => onChange(value.filter((v) => !(v.id === r.id && v.type === r.type)))} className="hover:text-[#0D1B2A]"><X size={12} /></button>
            </span>
          ))}
        </div>
      )}
    </div>
  );
};
